// Copyright Prashant Vaghela, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
export const eventsItems = [
  {
    name: 'my-instance-1',
    id: 'i-b4b5f3b29ac6f0e',
    type: 'instance-stop',
    statusText: 'Scheduled',
    status: 'pending',
  },
  {
    name: 'my-instance-2',
    id: 'i-f0eb5f329ab4bc6',
    type: 'instance-stop',
    statusText: 'Scheduled',
    status: 'pending',
  },
  {
    name: 'my-instance-3',
    id: 'i-29ab4bebc6f05f3',
    type: 'instance-stop',
    statusText: 'Ongoing',
    status: 'success',
  },
  {
    name: 'my-instance-4',
    id: 'i-329ab4bc6f0eb5f',
    type: 'instance-stop',
    statusText: 'Ongoing',
    status: 'success',
  },
  {
    name: 'my-instance-5',
    id: 'i-b4beb29a5f3c6f0',
    type: 'instance-stop',
    statusText: 'Ongoing',
    status: 'success',
  },
  {
    name: 'my-instance-6',
    id: 'i-f0eb5f329ab4bc6',
    type: 'instance-stop',
    statusText: 'Ongoing',
    status: 'success',
  },
  {
    name: 'my-instance-7',
    id: 'i-2029b8187f0e6e',
    type: 'instance-stop',
    statusText: 'Ongoing',
    status: 'success',
  },
];
